<template>
  <div class="quickEntryConfig">
    <el-dialog
      title="快速入口配置"
      :visible.sync="isShowDialog"
      width="600">
      <!-- <el-transfer v-model="checked" :data="data"></el-transfer> -->
      <div class="content_box">
        <div class="left">
          <div class="head">
            <el-checkbox class="allCheck" v-model="leftChecked" @change="leftChange">可选择项</el-checkbox>
            <span class="num">{{leftCheckList.length + '/' + leftList.length}}</span>
          </div>
          <div class="list">
            <el-checkbox-group v-model="leftCheckList" @change="leftListChange">
              <el-checkbox v-for="item in leftList" :key="item.id" :label="item.id">{{item.resourceName}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="center">
          <el-button @click="add" type="primary" icon="el-icon-arrow-right"></el-button>
          <el-button @click="del" type="primary" icon="el-icon-arrow-left"></el-button>
        </div>
        <div class="right">
          <div class="head">
            <el-checkbox class="allCheck" v-model="rightChecked" @change="rightChange">可选择项</el-checkbox>
            <span class="num">{{rightCheckList.length + '/' + rightList.length}}</span>
          </div>
          <div class="list">
            <el-checkbox-group v-model="rightCheckList" @change="rightListChange">
              <el-checkbox v-for="(item, i) in rightList" :key="item.id" :label="item.id">
                <p @dragstart="dragstart" @drop="drop" @dragover="dragover" draggable="true" :data-index="i">
                  {{item.resourceName}}
                  <span style="float: right"><i class="el-icon-s-fold"></i></span>
                </p>
                <!-- <span>{{item.resourceName}}</span> -->
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveResources">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getAllResources, getUserResources, saveResources } from '@/api/businessAnalysis'
export default {
  props: {
    btnJurisdiction: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShowDialog: false,
      checked: [],
      allList: [
        {
          id: 1,
          name: '菜单1'
        },
        {
          id: 2,
          name: '菜单2'
        },
        {
          id: 3,
          name: '菜单3'
        },
        {
          id: 4,
          name: '菜单4'
        }
      ],
      leftList: [],
      leftCheckList: [],
      leftChecked: false,
      rightList: [],
      rightChecked: false,
      rightCheckList: [],
      itemIndex: '',
      dragItem: null
    }
  },
  methods: {
    init () {
      this.isShowDialog = true
      this.getAllResources()
      this.getUserResources()
    },
    leftChange (val) {
      if (val) {
        this.leftCheckList = this.leftList.map(item => item.id)
      } else {
        this.leftCheckList = []
      }
    },
    rightChange (val) {
      if (val) {
        this.rightCheckList = this.rightList.map(item => item.id)
      } else {
        this.rightCheckList = []
      }
    },
    leftListChange () {
      if (this.leftCheckList.length === this.leftList.length) {
        this.leftChecked = true
      } else {
        this.leftChecked = false
      }
    },
    rightListChange () {
      if (this.rightCheckList.length === this.rightList.length) {
        this.rightChecked = true
      } else {
        this.rightChecked = false
      }
    },
    add () {
      let checkedList = this.rightList.map(i => i.id)
      this.allList.forEach((item) => {
        if (this.leftCheckList.includes(item.id)) {
          if (!checkedList.includes(item.id)) this.rightList.push(item)
        }
      })
      this.leftCheckList = []
      this.leftChecked = false
      this.rightChecked = false
    },
    del () {
      this.rightCheckList.forEach(item => {
        for(let i in this.rightList) {
          if (item === this.rightList[i].id){
            this.rightList.splice(i, 1)
            break
          }
        }
      })
      this.leftChecked = false
      this.rightChecked = false
      this.rightCheckList = []
    },
    dragstart (event) {
      this.itemIndex = event.target.getAttribute('data-index')
      this.dragItem = this.rightList[this.itemIndex]
    },
    drop (event) {
      const index = event.target.getAttribute('data-index')
      this.rightList.splice(this.itemIndex, 1)
      console.log(index)
      this.rightList.splice(index, 0, this.dragItem)
    },
    dragover (event) {
      event.preventDefault()
    },
    handleClose () {
      this.leftChecked = this.rightChecked = false
      this.rightList = []
      this.rightCheckList = this.leftCheckList = []
      this.isShowDialog = false
    },
    async getAllResources () {
      try {
        const { code, result } = await getAllResources()
        if (code !== 200) return
        this.allList = result
        this.leftList = result
      } catch (error) {
        console.log(error)
      }
    },
    async getUserResources () {
      try {
        const { code, result } = await getUserResources()
        if (code !== 200) return
        this.rightList = result
      } catch (error) {
        console.log(error)
      }
    },
    async saveResources () {
      try {
        const { code } = await saveResources({ resourcesJson: this.rightList })
        if (code !== 200) return
        this.$message.success('操作成功')
        this.$emit('submitResources')
        this.handleClose()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
/deep/ .allCheck .el-checkbox__label {
  width: 100px !important;
}
</style>